/* ======================================================================
   МОДУЛЬ: WEB PUSH УВЕДОМЛЕНИЯ (web-push.js)
   (Браузерные пуши для удержания и напоминаний об уроках)
   ====================================================================== */

function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');
  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);
  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function initWebPushSystem() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return;
  }

  // Регистрация Service Worker
  navigator.serviceWorker.register('/sw.js', { scope: '/' })
    .then(function(reg) {
      // Если разрешение уже получено - синхронизируем подписку
      if (Notification.permission === 'granted') {
        reg.pushManager.getSubscription().then(function(existingSub) {
          if (existingSub) {
            sendSubscriptionToBackend(existingSub);
          } else {
            subscribeUserToPush(reg, false);
          }
        });
      } else if (Notification.permission === 'default') {
        // Показываем деликатный запрос через 22 секунды
        setTimeout(function() {
          showPushPermissionBanner(reg);
        }, 22000);
      }
    })
    .catch(function(err) {
      console.warn('[WebPush] Ошибка регистрации sw.js:', err);
    });
}

function showPushPermissionBanner(reg) {
  try {
    if (sessionStorage.getItem('meta_push_dismissed') === 'true') {
      return;
    }
  } catch (e) {}

  if (document.getElementById('metaPushPromptBanner')) {
    return;
  }

  var banner = document.createElement('div');
  banner.id = 'metaPushPromptBanner';
  banner.className = 'meta-push-banner';
  banner.innerHTML = `
    <div class="meta-push-banner-content">
      <span class="meta-push-bell">🔔</span>
      <div class="meta-push-text">
        <div class="meta-push-title">Напоминания об уроках</div>
        <div class="meta-push-desc">Включите уведомления, чтобы не пропустить выход видеоразборов и практик</div>
      </div>
      <div class="meta-push-actions">
        <button type="button" class="meta-push-btn-accept" id="metaPushAcceptBtn">Включить</button>
        <button type="button" class="meta-push-btn-later" id="metaPushLaterBtn">Позже</button>
      </div>
    </div>
  `;

  document.body.appendChild(banner);
  setTimeout(function() {
    banner.classList.add('is-visible');
  }, 50);

  var acceptBtn = document.getElementById('metaPushAcceptBtn');
  var laterBtn = document.getElementById('metaPushLaterBtn');

  if (acceptBtn) {
    acceptBtn.addEventListener('click', function() {
      banner.classList.remove('is-visible');
      setTimeout(function() { banner.remove(); }, 300);
      subscribeUserToPush(reg, true);
    });
  }

  if (laterBtn) {
    laterBtn.addEventListener('click', function() {
      try {
        sessionStorage.setItem('meta_push_dismissed', 'true');
      } catch (e) {}
      banner.classList.remove('is-visible');
      setTimeout(function() { banner.remove(); }, 300);
    });
  }
}

async function subscribeUserToPush(reg, isUserAction) {
  try {
    var permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return;
    }

    // Запрашиваем публичный VAPID ключ
    var res = await fetch('/api/push/vapid-key');
    if (!res.ok) return;
    var data = await res.json();
    var pubKey = data.public_key;
    if (!pubKey) return;

    var convertedKey = urlBase64ToUint8Array(pubKey);
    var sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedKey
    });

    await sendSubscriptionToBackend(sub);

    if (isUserAction) {
      if (typeof triggerHaptic === 'function') triggerHaptic('success');
    }
  } catch (err) {
    console.warn('[WebPush] Ошибка подписки на пуши:', err);
  }
}

async function sendSubscriptionToBackend(subscription) {
  try {
    var prof = {};
    try {
      prof = JSON.parse(localStorage.getItem('meta_user_profile') || '{}');
    } catch (e) {}

    var payload = {
      subscription: subscription.toJSON ? subscription.toJSON() : subscription,
      user_id: prof.id || null,
      telegram_id: prof.telegramId || prof.telegram_id || null
    };

    await fetch('/api/push/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  } catch (err) {
    console.warn('[WebPush] Ошибка сохранения подписки:', err);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWebPushSystem);
} else {
  initWebPushSystem();
}